<div
  class="tw-flex sm:tw-flex-col tw-items-center sm:tw-items-start tw-gap-2 sm:tw-gap-1 tw-font-medium tw-leading-[125%] tw-tracking-[0.004em] tw-h-full tw-justify-between sm:tw-justify-center"
>
  <span [class]="colorClass"> {{ value > 0 ? "+" : "" }}{{ value | number: "1.2-2" }} </span>

  <span *ngIf="label" [class]="tagClass">
    {{ label }}
  </span>
</div>
